import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {RoleService} from '@core/modules/role/services/role.service';
import {TokenService} from '@core/modules/authentication/services';
import {BootstrapLicenseDataService} from '@core/services';
import {SUBSCRIPTIONS__LICENSE_ROUTE} from '@core/constants/navigation';
import {Roles} from '@core/modules/role/enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class LicenseGuard  {
  constructor(
    private router: Router,
    private bootstrapLicenseData: BootstrapLicenseDataService,
    private role: RoleService,
    private token: TokenService,
  ) {

  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.token.isToken || this.role.isRole(Roles.Admin)) {
      return true;
    }

    if (this.bootstrapLicenseData.getBootstrapData().active) {
      return true;
    }

    this.router.navigateByUrl(SUBSCRIPTIONS__LICENSE_ROUTE);
    return false;
  }
}
